/**
 * 应用入口文件
 * 
 * 初始化Vue应用，配置全局依赖（路由、状态管理），并挂载到DOM节点。
 * 这是整个前端应用的启动入口，所有全局配置和插件都在此处注册。
 */

// 引入Vue核心库
import Vue from "vue";

// 引入根组件
import App from "./App.vue";
// 引入路由配置
import router from "./router";
// 引入状态管理
import store from "./store";
// 引入全局样式
import "@/styles/global.css";

/**
 * 生产环境提示配置
 * 
 * 设置为false关闭Vue在生产环境的开发提示，减少控制台输出，提升性能。
 */
Vue.config.productionTip = false;

/**
 * 创建并挂载Vue实例
 * 
 * 将路由(router)和状态管理(store)注入Vue实例，
 * 通过render函数渲染根组件App，并挂载到id为"app"的DOM节点上。
 */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
